import { Container, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import bgImage from '../../../assets/CCImages/bg-title-page.png'
import { personalCreditCardAdapter } from './auxiliarData/personalCreditCardInfo'
import CreditCardInfo from './CreditCardInfo/CreditCardInfo'
import { useParams } from 'react-router-dom'
import CreditCardsSelected from './CreditCardsSelected/CreditCardsSelected'
import CreditCardComparison from './CreditCardComparison/CreditCardComparison'
import { useDispatch, useSelector } from 'react-redux'
import { getCreditCards, setCardSelected } from './store'
import { Spinner } from '../../../Components/BackDrop'

const SelectCreditCard = () => {
  const dispatch = useDispatch()
  const { catalog } = useSelector((state) => state.availableCreditCard)
  const [cards, setCards] = useState([])
  const [selectedCC, setSelectedCC] = useState([])
  const [pending, setPending] = useState(true)
  const [disabledCheck, setDisabledCheck] = useState(false)
  const [comparisson, setComparisson] = useState(false)

  useEffect(() => {
    if (selectedCC.length >= 3) setDisabledCheck(true)
    else setDisabledCheck(false)

    dispatch(setCardSelected(selectedCC))
  }, [selectedCC])

  const params = useParams()

  useEffect(() => {
    setPending(true)
    dispatch(getCreditCards()).finally(() => {
      setPending(false)
    })
  }, [])

  useEffect(() => {
    if (catalog) {
      const cards = personalCreditCardAdapter(catalog.options)
      setCards(cards)
    }
  }, [catalog])

  return (
    <>
      <Spinner open={pending} />
      {!pending && (
      <React.Fragment>
        <Container style={{ marginBottom: '10rem' }}>
          {!comparisson ? (
            <>
              <div
                style={{
                  backgroundImage: `url(${bgImage})`,
                  height: '70px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: '2rem'
                }}
              >
                <Typography color='#fff' variant='h5'>
                  {catalog.segment === 'Individual'
                    ? 'Personal Credit Cards.'
                    : 'Business Credit Cards.'}
                </Typography>
              </div>
              <Container>
                {cards.length > 0
                  ? cards.map((cardInfo) => (
                      <CreditCardInfo
                        disabledCheck={disabledCheck || cardInfo.disabled }
                        setSelectedCC={setSelectedCC}
                        key={cardInfo.id}
                        cardInfo={cardInfo}
                      />
                    ))
                  : null}
              </Container>
            </>
          ) : (
            <CreditCardComparison
              setComparisson={setComparisson}
              selectedCC={selectedCC}
              params={params}
            />
          )}
        </Container>
        {!comparisson && (
          <CreditCardsSelected
            setSelectedCC={setSelectedCC}
            setComparisson={setComparisson}
            selectedCC={selectedCC}
            params={params}
          />
        )}
      </React.Fragment>
      )}
    </>
  )
}

export default SelectCreditCard
